import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useSpaceEnabledContentTypesQuery from './CreateContentPopover/__generated__/useSpaceEnabledContentTypesQuery.graphql.ts';
import type {
	useSpaceEnabledContentTypesQuery$data,
	useSpaceEnabledContentTypesQuery$variables,
} from './CreateContentPopover/__generated__/useSpaceEnabledContentTypesQuery.graphql.ts';

export function preloadSpaceEnabledContentTypes(spaceKey: string) {
	return query<useSpaceEnabledContentTypesQuery$data, useSpaceEnabledContentTypesQuery$variables>({
		query: useSpaceEnabledContentTypesQuery,
		errorPolicy: 'all',
		variables: {
			spaceKey,
		},
	});
}
